const moment = require('moment');

angular
  .module('percentCouponsAdd')
  .component('percentCouponsAdd', {
    template: require('./percent-coupons-add.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$timeout', '$translate', 'AuthService', 'envService',
      function PercentCouponsAddViewController($rootScope, $scope, $resource, $route, $location, $window, $timeout, $translate, AuthService, envService) {

        $rootScope.mainmenu = 'coupons';
        $rootScope.menu = 'percent';
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        $resource(`${APIURL}/admin/goods/types`).get({}, (types) => {
          console.log(types);
          this.goodsTypes = types.goodsTypes;
        }, (err) => {
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        $resource(`${APIURL}/admin/goods/options/names`).get({}, (data) => {
          console.log(data);
          this.options = data.options;
        }, (err) => {
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        let _searchTimeout;
        this.newcoupon = { STARTDATE: `${moment().format('YYYY/MM/DD')}`,
          ENDDATE: `${moment().add(30, 'days').format('YYYY/MM/DD')}`,
          GOODS_TYPE: '',
          OPTION_NAME: '',
          PERCENT: 10,
          COUNT: 1,
          MESSAGE: '',
          NOTE: '',
          MESSAGE_TYPE: '0' };
        this.selectedUsers = [];

        this.openUsers = () => {
          this.userSearch = { query: '', result: [] };
          jQuery('#modal-user').modal('show');
        };
        this.hideUsers = () => {
          jQuery('#modal-user').modal('hide');
        };
        this.searchUsers = () => {
          console.log('searchUsers');
          if (_searchTimeout) { // if there is already a timeout in process cancel it
            $timeout.cancel(_searchTimeout);
          }
          console.log('searchUsers 2');
          _searchTimeout = $timeout(() => {
            console.log('searchUsers 3');
            $resource(`${APIURL}/admin/users`).get({ q: this.userSearch.query, count: -1 }, (data) => {
              this.userSearch.result = data.users;
              console.log(data);
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
          }, 500);
        };
        this.selectUser = (user) => {
          for (let idx = 0; idx < this.selectedUsers.length; idx += 1) {
            const testUser = this.selectedUsers[idx];
            if (testUser.ID == user.ID) { // eslint-disable-line eqeqeq
              this.selectedUsers.splice(idx, 1);
              return;
            }
          }
          this.selectedUsers.push(user);
        };
        this.isUserSelected = (user) => {
          const users = this.selectedUsers.filter(testUser => testUser.ID == user.ID); // eslint-disable-line eqeqeq
          return users.length > 0;
        };
        this.requestProduct = (user) => {
          const users = this.selectedUsers.filter(testUser => testUser.ID == user.ID); // eslint-disable-line eqeqeq
          return users.length > 0;
        };
        this.submit = () => {
          if (this.newcoupon.MESSAGE_TYPE === '0') {
            this.newcoupon.MESSAGE = '고객님께 할인쿠폰이 발급 되었습니다.';
          } else if (this.newcoupon.MESSAGE_TYPE === '1') {
            this.newcoupon.MESSAGE = '고객님께 결빙취소쿠폰이 발급 되었습니다.';
          } else if (this.newcoupon.MESSAGE_TYPE === '2') {
            this.newcoupon.MESSAGE = '고객님께 우천취소쿠폰이 발급 되었습니다.';
          }
          if (this.newcoupon.MESSAGE_TYPE === '3' && this.selectedUsers.length > 0 && (!this.newcoupon.MESSAGE || this.newcoupon.MESSAGE.length < 1)) {
            alert($translate.instant('메세지를 입력해주세요.'));
            return;
          }
          if (!moment(this.newcoupon.STARTDATE, 'YYYY/MM/DD', true).isValid()) {
            alert($translate.instant('올바른 유효기간:시작일을 입력해주세요.(예:2016/01/01)'));
            return;
          }
          if (!moment(this.newcoupon.ENDDATE, 'YYYY/MM/DD', true).isValid()) {
            alert($translate.instant('올바른 유효기간:만료일을 입력해주세요.(예:2016/01/01)'));
            return;
          }
          if (!moment(this.newcoupon.ENDDATE, 'YYYY/MM/DD', true).isAfter(moment(this.newcoupon.STARTDATE, 'YYYY/MM/DD', true))) {
            alert($translate.instant('만료일은 시작일 보다 커야 합니다.'));
            return;
          }
          if (this.newcoupon.GOODS_TYPE < 1) {
            alert($translate.instant('상품을 선택해주세요.'));
            return;
          }
          if (this.newcoupon.PERCENT < 0) {
            alert($translate.instant('퍼센트를 입력해주세요.'));
            return;
          }
          if (this.newcoupon.COUNT < 1) {
            alert($translate.instant('쿠폰수를 입력해주세요.'));
            return;
          }
          if (this.newcoupon.NOTE.length < 1) {
            alert($translate.instant('발급사유를 입력해주세요.'));
            return;
          }

          this.newcoupon.TB_USER_ID = [];
          for (let idx = 0; idx < this.selectedUsers.length; idx += 1) {
            this.newcoupon.TB_USER_ID.push(this.selectedUsers[idx].ID);
          }

          this.newcoupon.DESCRIPTION = $translate.instant('오프라인');
          if (this.selectedUsers.length > 0) {
            this.newcoupon.QUANTITY_PER_CODE = 1;
            this.newcoupon.CODE_PREFIX = '';
            this.newcoupon.COUPON_VALID_DAYS = undefined;

            this.newcoupon.DESCRIPTION = `${this.selectedUsers[0].NAME}(${this.selectedUsers[0].TEL}/${this.selectedUsers[0].ADDR})`;
            if (this.selectedUsers.length > 2) {
              this.newcoupon.DESCRIPTION = `${this.newcoupon.DESCRIPTION}외 ${this.selectedUsers.length - 1}명`;
            }
          } else {
            this.newcoupon.MESSAGE = '';
          }

          $resource(`${APIURL}/admin/percent/coupons`).save(this.newcoupon).$promise
            .then(() => {
              $location.path('/percent/coupons');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/percent-coupons-add/percent-coupons-add.component.js